import { render, staticRenderFns } from "./GenericPictureUpload.vue?vue&type=template&id=92620242"
import script from "./GenericPictureUpload.vue?vue&type=script&lang=js"
export * from "./GenericPictureUpload.vue?vue&type=script&lang=js"
import style0 from "./GenericPictureUpload.vue?vue&type=style&index=0&id=92620242&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports